
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    deleteViewership, viewershipSearch
} from "./ViewershipClient";

import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeViewership} from "./viewershipSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import ViewershipDrawer from "./ViewershipDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import Button from "@mui/material/Button";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import SearchIcon from "@mui/icons-material/Search";
import ViewershipSearch from "./ViewershipSearch";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {UsersGridColumns} from "../../Users/UsersGridColumns";
import {changeUsers} from "../../Users/usersSlice";
import {ViewershipGridColumns} from "./ViewershipGridColumns";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import ViewershipInfoDialogue from "./Info/ViewershipInfoDialogue";

// main function
export default function ViewershipGrid() {

    // ****************** BEGIN STATES ****************************

    const [viewerships, setViewerships] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [viewershipInfoOpen, setViewershipInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorViewershipId = useSelector((state) => state.viewershipSlc.value.id);
    const selectorDrawerState = useSelector((state) => state.viewershipSlc.value.viewershipDrawerState);

    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectorProductId = useSelector((state) => state.viewershipSearchSlc.value.productId);
    const selectorProductName = useSelector((state) => state.viewershipSearchSlc.value.productName);
    const selectorEpisodeName = useSelector((state) => state.viewershipSearchSlc.value.episodeName);
    const selectorPhotoStartDateFrom = useSelector((state) => state.viewershipSearchSlc.value.photoStartDateFrom);
    const selectorPhotoStartDateTo = useSelector((state) => state.viewershipSearchSlc.value.photoStartDateTo);
    const selectorSeriesExternalId = useSelector((state) => state.viewershipSearchSlc.value.seriesExternalId);
    const selectorSeriesName = useSelector((state) => state.viewershipSearchSlc.value.seriesName);
    const selectorSeasonExternalId = useSelector((state) => state.viewershipSearchSlc.value.seasonExternalId);
    const selectorSeasonNumberFrom = useSelector((state) => state.viewershipSearchSlc.value.seasonNumberFrom);
    const selectorSeasonNumberTo = useSelector((state) => state.viewershipSearchSlc.value.seasonNumberTo);
    const selectorSeasonName = useSelector((state) => state.viewershipSearchSlc.value.seasonName);
    const selectorPlatformId = useSelector((state) => state.usageSearchSlc.value.platformId);
    const selectorPlatformName = useSelector((state) => state.usageSearchSlc.value.platformName);
    const selectorService = useSelector((state) => state.usageSearchSlc.value.service);
    const selectorUsageMarket = useSelector((state) => state.usageSearchSlc.value.usageMarket);
    const selectorTerritory = useSelector((state) => state.usageSearchSlc.value.territory);
    const selectorViewDateFrom = useSelector((state) => state.viewershipSearchSlc.value.viewDateFrom);
    const selectorViewDateTo = useSelector((state) => state.viewershipSearchSlc.value.viewDateTo);
    const selectorViewsFrom = useSelector((state) => state.viewershipSearchSlc.value.viewsFrom);
    const selectorViewsTo = useSelector((state) => state.viewershipSearchSlc.value.viewsTo);
    const selectorViewedMinutesFrom = useSelector((state) => state.viewershipSearchSlc.value.viewedMinutesFrom);
    const selectorViewedMinutesTo = useSelector((state) => state.viewershipSearchSlc.value.viewedMinutesTo);
    const selectorRatingFrom = useSelector((state) => state.viewershipSearchSlc.value.ratingFrom);
    const selectorRatingTo = useSelector((state) => state.viewershipSearchSlc.value.ratingTo);
    const selectorId = useSelector((state) => state.viewershipSearchSlc.value.id);
    const selectorExternalId = useSelector((state) => state.viewershipSearchSlc.value.externalId);
    const selectorSource = useSelector((state) => state.viewershipSearchSlc.value.source);
    const selectorStatus = useSelector((state) => state.viewershipSearchSlc.value.status);
    const selectorParticipations = useSelector((state) => state.viewershipSearchSlc.value.participations);
    const selectorResiduals = useSelector((state) => state.viewershipSearchSlc.value.residuals);
    const selectorRoyalties = useSelector((state) => state.viewershipSearchSlc.value.royalties);

    const selectedId = useSelector((state) => state.viewershipSlc.value.id);

    const dispatchData = useDispatch();

    const selectorViewershipGridRefresh = useSelector((state) => state.viewershipSlc.value.viewershipGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************
//
//     const fetchViewership = () =>{
// console.log("Viewership search triggered");
//         if(
//             selectorProductId !== null ||
//             selectorProductName !== null ||
//             selectorEpisodeName !== null ||
//             selectorPhotoStartDateFrom !== null ||
//             selectorPhotoStartDateTo !== null ||
//             selectorSeriesExternalId !== null ||
//             selectorSeriesName !== null ||
//             selectorSeasonExternalId !== null ||
//             selectorSeasonNumberFrom !== null ||
//             selectorSeasonNumberTo !== null ||
//             selectorSeasonName !== null ||
//             selectorPlatformId !== null ||
//             selectorPlatformName !== null ||
//             selectorService !== null ||
//             selectorUsageMarket !== null ||
//             selectorTerritory !== null ||
//             selectorViewDateFrom !== null ||
//             selectorViewDateTo !== null ||
//             selectorViewsFrom !== null ||
//             selectorViewsTo !== null ||
//             selectorViewedMinutesFrom !== null ||
//             selectorViewedMinutesTo !== null ||
//             selectorRatingFrom !== null ||
//             selectorRatingTo !== null ||
//             selectorId !== null ||
//             selectorExternalId !== null ||
//             selectorSource !== null ||
//             selectorStatus !== null ||
//             selectorParticipations !== null ||
//             selectorResiduals !== null ||
//             selectorRoyalties !== null
//         )
//         {
//             {
//                 viewershipSearch(
//                     selectorProductId,
//                     selectorProductName,
//                     selectorEpisodeName,
//                     selectorPhotoStartDateFrom,
//                     selectorPhotoStartDateTo,
//                     selectorSeriesExternalId,
//                     selectorSeriesName,
//                     selectorSeasonExternalId,
//                     selectorSeasonNumberFrom,
//                     selectorSeasonNumberTo,
//                     selectorSeasonName,
//                     selectorPlatformId,
//                     selectorPlatformName,
//                     selectorService,
//                     selectorUsageMarket,
//                     selectorTerritory,
//                     selectorViewDateFrom,
//                     selectorViewDateTo,
//                     selectorViewsFrom,
//                     selectorViewsTo,
//                     selectorViewedMinutesFrom,
//                     selectorViewedMinutesTo,
//                     selectorRatingFrom,
//                     selectorRatingTo,
//                     selectorId,
//                     selectorExternalId,
//                     selectorSource,
//                     selectorStatus,
//                     selectorParticipations,
//                     selectorResiduals,
//                     selectorRoyalties
//                 )

//                     .then(data => {
//                             // console.log("productSearchCriteria slice");
//                             // console.log(productSearchCriteria);
//                             console.log("Viewership Data");
//                             console.log(data);
//                             setViewerships(data);
//                         }
//                     )
//             }
//         }
//         else{console.log("search triggered, nothing to search.")}}
    const fetchViewership = () => {

        console.log("Viewership search triggered");

        const request = {

            productId: selectorProductId,

            productName: selectorProductName,

            episodeName: selectorEpisodeName,

            photoStartDateFrom: selectorPhotoStartDateFrom,
            photoStartDateTo: selectorPhotoStartDateTo,

            seriesExternalId: selectorSeriesExternalId,

            seriesName: selectorSeriesName,

            seasonExternalId: selectorSeasonExternalId,

            seasonNumberFrom: selectorSeasonNumberFrom,
            seasonNumberTo: selectorSeasonNumberTo,

            seasonName: selectorSeasonName,

            platformId: selectorPlatformId,

            platformName: selectorPlatformName,

            service: selectorService,

            usageMarket: selectorUsageMarket,

            territory: selectorTerritory,

            viewDateFrom: selectorViewDateFrom,
            viewDateTo: selectorViewDateTo,

            viewsFrom: selectorViewsFrom,
            viewsTo: selectorViewsTo,

            viewedMinutesFrom: selectorViewedMinutesFrom,
            viewedMinutesTo: selectorViewedMinutesTo,

            ratingFrom: selectorRatingFrom,
            ratingTo: selectorRatingTo,

            id: selectorId,

            externalId: selectorExternalId,

            source: selectorSource,

            status: selectorStatus,

            participations: selectorParticipations,

            residuals: selectorResiduals,

            royalties: selectorRoyalties
        };

        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            dispatchData(changeExternalData({ submitting: true }));

            viewershipSearch(request)

                .then(data => {

                    console.log("Viewership Data");

                    console.log(data);

                    setViewerships(data);

                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }


                })

                .catch(err => {

                    console.error(err);

                })

                .finally(() => {

                    // setSubmitting(false);
                    dispatchData(changeExternalData({ submitting: false }));
                });


        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    // ****************** END FETCH ****************************


    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Viewership"}));
    };

        function handleSearch(){
            setShowSearch(!showSearch)
        }

    // useEffect(() => {
    //     fetchViewership();
    //     dispatchData(changeViewership({viewershipGridRefresh: false}));
    // }, [useSelector((state) => state.viewershipSlc.value.viewershipGridRefresh)===true]);



    useEffect(() => {

        if (selectorViewershipGridRefresh) {

            fetchViewership();

            dispatchData(changeViewership({
                viewershipGridRefresh: false
            }));
        }

    }, [selectorViewershipGridRefresh]);

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeViewership({                    id: null, externalId: null, productId: null, platformId: null,
            viewDate: null, views: null, viewedMinutes: null, rating: null, source: null,
            status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            platformCode: null, platformName: null,
            service: null, platformTerritory: null, usageMarket: null, platformOwner: null,
            propertyName: null, initialMarket: null, genre: null, productionType: null,
            viewershipDrawerState: true, viewershipDrawerMode: "Add"}));
    };


    const removeViewership = () => {
        deleteViewership(selectorViewershipId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeViewership({viewershipGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }


    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };

    function DeleteConfirmationDialog() {
        // const [open, setOpen] = useState(false);

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            deleteViewership(selectedId).then(() => {
                setDeleteOpen(false);
                dispatchData(changeViewership({viewershipGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };


    const gridClear = () => {

        setViewerships([]);
    }

    // ****************** END CRUD ***********************************


    const handleClickedRow = (viewerships) => {

        console.log('Viewership data from clicked row');
        console.log(viewerships);
        dispatchData(changeViewership({id: viewerships.id, externalId: viewerships.externalId,
            productId: viewerships.productId, platformId: viewerships.platformId,
            viewDate: viewerships.viewDate,views: viewerships.views,viewedMinutes: viewerships.viewedMinutes,
            rating: viewerships.rating,source: viewerships.source,
            status: viewerships.status,
            createdOn: viewerships.createdOn,createdBy:viewerships.createdBy,
            lastModifiedOn:viewerships.lastModifiedOn,lastModifiedBy:viewerships.lastModifiedBy,
            platformCode: viewerships.platformCode, platformName: viewerships.platformName,
            service: viewerships.service, platformTerritory: viewerships.platformTerritory,
            usageMarket: viewerships.usageMarket, platformOwner: viewerships.platformOwner,
            propertyName: viewerships.propertyName, initialMarket: viewerships.initialMarket,
            genre: viewerships.genre, productionType: viewerships.productionType
}));
    };


    const handleViewershipInfo = () => {
        setViewershipInfoOpen(true);
    };

    const handleCloseViewershipInfo = () => {
        setViewershipInfoOpen(false);
    };



    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleViewershipInfo()}
                    >Viewership</h3>
                    </Tooltip>
                       <ViewershipInfoDialogue
                            open={viewershipInfoOpen}
                            onClose={handleCloseViewershipInfo}
                        />
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
            {showSearch && <ViewershipSearch
                gridClear = {gridClear}
            />}
                {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <ViewershipDrawer
            />}
            {/*}*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Viewerships"}
                rows={viewerships}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={ViewershipGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeViewership({ viewershipDrawerState: true, viewershipDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeViewership({ viewershipDrawerState: true, viewershipDrawerMode: "Clone" })),
                    onDelete: removeViewership
                })}
                onRowClick = {(viewerships)=>handleClickedRow(viewerships.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={viewership => viewership.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}

